import React from "react"
import Layout from "../components/layout"
import { Link } from 'gatsby'
import site from '../constants/site'
import './index.css'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import 'react-lazy-load-image-component/src/effects/blur.css'
import collections from '../constants/collections'


const IndexPage = (props) => {
  const { aboutCollection } = site
  const aboutCollectionRender = aboutCollection.map(item => <p id="index-text">{item}</p>)
  return (
    <Layout location={props.location}>
      <div id="index-page">
        <Link to={`/collections/${collections[0].route}`}>
          <LazyLoadImage
            alt=""
            effect="blur"
            src={site.indexImage} 
            className="index-image"
          />
        </Link>
      </div>
      {aboutCollectionRender}
    </Layout>
  )
}

export default IndexPage
